import { defineMessages } from 'react-intl';

const messages = defineMessages({
  showHistory: {
    id: 'App.SecurityDepositInterestTable.showHistory',
    defaultMessage: 'Show History',
  },
  hideHistory: {
    id: 'App.SecurityDepositInterestTable.hideHistory',
    defaultMessage: 'Hide History',
  },
  startDate: {
    id: 'App.SecurityDepositInterestTable.startDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'App.SecurityDepositInterestTable.endDate',
    defaultMessage: 'End Date',
  },
  interestRate: {
    id: 'App.SecurityDepositInterestTable.interestRate',
    defaultMessage: 'Simple Interest %',
  },
  addNewRate: {
    id: 'App.SecurityDepositInterestTable.addNewRate',
    defaultMessage: 'Add New Rate',
  },
});

export default messages;
